import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const ChatContainer = styled.div`
  width: 100%;
  max-width: 600px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  overflow: hidden;
  margin-left: 20%;
`;

export const MessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column-reverse;
  gap: ${theme.spacing.md};
  mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 10%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    transparent 0%,
    black 10%
  );

  /* Hide scrollbar but keep functionality */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const InputContainer = styled.div`
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  display: flex;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(0, 0, 0, 0.2) 20%,
      rgba(0, 0, 0, 0.2) 80%,
      transparent
    );
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: rgba(255, 255, 255, 0.4);
  border: 2px solid rgba(0, 0, 0, 0.4);
  border-radius: 24px;
  color: ${theme.colors.sumi};
  font-size: 1.1rem;
  font-family: 'M PLUS Rounded 1c', sans-serif;
  transition: all ${theme.transitions.fast};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  &:hover {
    border-color: rgba(0, 0, 0, 0.6);
    background: rgba(255, 255, 255, 0.5);
  }

  &:focus {
    outline: none;
    border-color: rgba(0, 0, 0, 0.8);
    background: rgba(255, 255, 255, 0.6);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
    font-style: normal;
    font-size: 1rem;
  }
`;

export const SendButton = styled.button<{ disabled?: boolean }>`
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: transparent;
  color: ${theme.colors.sumi};
  border: 2px solid rgba(0, 0, 0, 0.6);
  border-radius: 20px;
  font-weight: 500;
  font-family: 'M PLUS Rounded 1c', sans-serif;
  transition: all ${theme.transitions.fast};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  min-width: 100px;

  &:not(:disabled):hover {
    border-color: rgba(0, 0, 0, 0.9);
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
  }
`; 